import React, { ReactElement, ReactNode } from 'react';
import { QueryResult } from 'react-query';
import { Alert } from 'react-bootstrap';
import LoadingScreen from '../../Common/LoadingScreen';

export type PropsDAffichageChargement<T> = {
    children: ReactNode | ((data: { data: T }) => ReactNode);
    query: QueryResult<T>;
    noAffichageChargement?: boolean;
    propsToPass?: any;
};

export default function AffichageChargement<T>(props: PropsDAffichageChargement<T>): ReactElement {
    const {
        query: { isLoading, isError, error, data },
        children,
        noAffichageChargement,
        propsToPass,
    } = props;

    let show = !noAffichageChargement;

    if (isLoading && show) {
        return <LoadingScreen />;
    }

    if (isError) {
        return (
            <Alert variant="danger">
                <strong>Une erreur est survenue :</strong> {(error as Error).message}
            </Alert>
        );
    }

    if (data) {
        if (typeof children === 'function') {
            return <>{children({ ...propsToPass, data })}</>;
        }
        if (React.isValidElement(children)) {
            return <>{React.cloneElement(children, { ...propsToPass, data: data })}</>;
        }
    }

    return <></>;
}
